import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumEquivalentUnit, EnumEquivalentUnitOption } from "./EnumEquivalentUnit";
import UiGroup from "./UiGroup";

/**
 * 箱型详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailParamContainerType extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * ISO
     */
    Iso?: string;
    /**
     * 95码
     */
    Code?: string;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 柜量
     */
    EquivalentUnit?: EnumEquivalentUnit;
}

/**
 * 箱型详细-表单校验
 */
export const DtoDetailParamContainerTypeRules = {
}

/**
 * 箱型详细-设置项
 */
export const DtoDetailParamContainerTypeMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "Iso",
    Label: "ISO",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Code",
    Label: "95码",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "NameZh",
    Label: "中文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "EquivalentUnit",
    Label: "柜量",
    Type: EnumMiezzFormItemType.Text,
    Pipe: EnumPipe.Enum,
    Options: EnumEquivalentUnitOption,
  },
]
